import { EditorContext, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { useSearchStore } from '#domains/search';
import { RichSearchInputExtension } from './extensions';

export const TextEditorProvider = ({ children }: React.PropsWithChildren) => {
  const setSearchString = useSearchStore(state => state.setSearchString);
  const commit = useSearchStore(state => state.commit);

  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        blockquote: false,
        bold: false,
        bulletList: false,
        code: false,
        codeBlock: false,
        dropcursor: false,
        gapcursor: false,
        hardBreak: false, // Disable hard breaks (Shift+Enter)
        heading: false,
        horizontalRule: false,
        italic: false,
        listItem: false,
        orderedList: false,
        strike: false
      }),
      RichSearchInputExtension.configure({ commit })
    ],
    onUpdate(props) {
      setSearchString(props.editor.$doc.textContent);
    }
  });

  return (
    <EditorContext.Provider value={{ editor }}>
      {children}
    </EditorContext.Provider>
  );
};
